var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#FF0000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2602 9.34267C21.9456 9.52718 22.4859 10.0675 22.6704 10.7529C23.0131 12.0049 22.9999 14.6145 22.9999 14.6145C22.9999 14.6145 22.9999 17.2108 22.6704 18.4629C22.4859 19.1482 21.9456 19.6886 21.2602 19.8731C20.0082 20.2026 15 20.2026 15 20.2026C15 20.2026 10.0049 20.2026 8.7397 19.8599C8.05436 19.6754 7.514 19.135 7.32949 18.4497C7 17.2108 7 14.6013 7 14.6013C7 14.6013 7 12.0049 7.32949 10.7529C7.514 10.0675 8.06754 9.514 8.7397 9.32949C9.99175 9 15 9 15 9C15 9 20.0082 9 21.2602 9.34267ZM13.4053 12.2026L17.57 14.6013L13.4053 16.9999V12.2026Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.30115074.svg";
export { ForwardRef as ReactComponent };